(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('GiftcardStatement', GiftcardStatement);

    GiftcardStatement.$inject = ['$resource', 'DateUtils'];

    function GiftcardStatement ($resource, DateUtils) {
        var resourceUrl =  'api/giftcard-statements/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dtIns = DateUtils.convertDateTimeFromServer(data.dtIns);
                        data.gcExpirationDate = DateUtils.convertDateTimeFromServer(data.gcExpirationDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
